import listQuery from '../../../graphql/queries/customer/CustomerGlobalContactListQuery.graphql';
import instanceQuery from '../../../graphql/queries/customer/CustomerGlobalContactQuery.graphql';
import fragment from '../../../graphql/fragments/customer/CustomerGlobalContactFragment.graphql';
import defaultQuery from '../../../graphql/queries/customer/CustomerGlobalContactDefault.graphql';
import workspaceQuery from '../../../graphql/queries/customer/CustomerGlobalContactWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { Direction } from '../../schema/p4types';
import mutationQuery from '../../mutations/customer/CustomerGlobalContactMutation.graphql';
import temporarySave from '../../mutations/customer/CustomerGlobalContactTempMutation.graphql';

const CustomerGlobalContact: EntityType = {
  type: 'CustomerGlobalContact',
  title: 'Customer Global Contacts',
  formTitle: 'Customer Global Contact',
  screenReference: 'CUSTOMER_GLOBAL_CONTACT',
  temporarySave: temporarySave,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name.fullName',
    customVariables: () => {
      return {
        orderBy: 'name',
        orderDirection: Direction.Asc,
        fetchFirst: 200,
      };
    },
  },
  fragment,
  default: defaultQuery,
  workspace: workspaceQuery,
  instance: instanceQuery,
  update: mutationQuery,
  workspaceUrl: '/Customers/CustomerGlobalContact/Workspace/',
  formUrl: '/Customers/CustomerGlobalContact/Details/',
};

export default CustomerGlobalContact;
